import OpenSeadragon, { extend } from '../../../openseadragon';

/**
 * 어노테이션 Store.
 * 과거에는 모듈 레벨 싱글톤이었으나, 듀얼 뷰어 지원을 위해 클래스로 변경.
 * 뷰어별로 new AppStore()로 인스턴스를 만들어 쓴다.
 *
 * Dispatcher도 인스턴스별로 분리되므로, 생성자에서 해당 dispatcher를 받아
 * register해둔다. 뷰어가 destroy될 때 unregister해야 메모리 누수가 없다.
 */
class AppStore extends OpenSeadragon.EventSource {
  constructor(dispatcher) {
    super();

    // 과거 모듈 스코프에 있던 data를 인스턴스 필드로 이동
    this.data = {
      mode: 'MOVE',
      zoom: 1,
      width: 0,
      height: 0,
      activityInProgress: false,
      annotations: [],
      rotation: 0,
      labelScale: 1, // 라벨 글씨 배율 (1 = 기본 크기, 최소값)
    };

    this.dispatcher = dispatcher;

    this.dispatchToken = dispatcher.register((action) => {
      const data = this.data;
      switch (action.type) {
        case 'MODE_UPDATE':
          data.mode = action.mode;
          break;

        case 'ACTIVITY_UPDATE':
          data.activityInProgress = action.inProgress;
          break;

        case 'ANNOTATIONS_CREATE':
          data.annotations.push(action.annotation);
          break;

        case 'ANNOTATIONS_UPDATE_LAST':
          extend(this.getLast()[1], action.update);
          break;

        case 'ANNOTATIONS_RESET':
          data.annotations = action.annotations;
          break;

        case 'ZOOM_UPDATE':
          data.zoom = action.zoom;
          break;

        case 'ROTATION_UPDATE':
          data.rotation = action.rotation;
          break;

        case 'LABEL_SCALE_UPDATE':
          data.labelScale = action.labelScale;
          break;

        case 'INITIALIZE':
          extend(data, action.options);
          break;

        default:
          break;
      }
      this.raiseEvent('CHANGE_EVENT');
    });
  }

  getAll() {
    return this.data.annotations;
  }

  getWidth() {
    return this.data.width * this.data.zoom;
  }

  getHeight() {
    return this.data.height * this.data.zoom;
  }

  getLast() {
    return this.data.annotations[this.data.annotations.length - 1];
  }

  getMode() {
    return this.data.mode;
  }

  inMoveMode() {
    return this.getMode() === 'MOVE';
  }

  notInMoveMode() {
    return !this.inMoveMode();
  }

  getZoomLevel() {
    return this.data.zoom;
  }

  getRotation() {
    return this.data.rotation;
  }

  getLabelScale() {
    return this.data.labelScale || 1;
  }

  setLabelScale(labelScale) {
    const next = Math.max(1, Number(labelScale) || 1);
    if (next === this.data.labelScale) return;
    this.dispatcher.dispatch({ type: 'LABEL_SCALE_UPDATE', labelScale: next });
  }

  isActivityInProgress() {
    return this.data.activityInProgress;
  }

  // Viewer destroy 시 호출해서 dispatcher 구독 해제 + 리스너 정리
  destroy() {
    if (this.dispatcher && this.dispatchToken != null) {
      try {
        this.dispatcher.unregister(this.dispatchToken);
      } catch (e) {
      }
      this.dispatchToken = null;
    }
    if (typeof this.removeAllHandlers === 'function') {
      this.removeAllHandlers('CHANGE_EVENT');
    }
  }
}

export default AppStore;
